import React from "react"

export const TRIGGERS = [
    { value: 'click', label: 'When a related hotspot or image is clicked', badge: 'ClickPop', hint: "ClickPop. In the KDF Editor, open the Image or Hotspot settings and set Click Action to 'Reveal ClickPop'." },
    { value: 'page', label: 'After time on a page', badge: 'TimedPop', hint: 'TimedPop. Can trigger on a specific page or on any page. Page number is optional.' },
    { value: 'doc', label: 'On entry', badge: 'EnterPop', hint: 'EnterPop. Remember to select it when you create a LaserLink.' },
    { value: 'onexit', label: 'On exit intent', badge: 'ExitPop', hint: 'ExitPop. Remember to select it when you create a LaserLink.' },
    { value: 'on_hide_reveal', label: 'On Hide/Reveal Action', badge: 'Hide/Reveal', hint: 'Assigns this lightbox to the Hide/Reveal Action.' },
];

export const triggerBadge = (display) => TRIGGERS.find((t) => t.value === display)?.badge ?? display;

const LightBoxTrigger = ({ lightBoxPayload, handleChange }) => (
    <div className="lb-trigger-list" role="radiogroup" aria-label="Trigger">
        {TRIGGERS.map(({ value, label, hint }) => (
            <label key={value} className={`lb-trigger-card${lightBoxPayload?.display === value ? ' active' : ''}`}>
                <input
                    type="radio"
                    name="display"
                    value={value}
                    checked={lightBoxPayload?.display === value}
                    onChange={handleChange}
                />
                <span className="lb-trigger-text">
                    <span className="lb-trigger-label">{label}</span>
                    <span className="lb-trigger-hint">{hint}</span>
                    {value === 'page' && (
                        <span className="lb-trigger-inline">
                            After
                            <input
                                type="number"
                                name="show_after"
                                min="0"
                                value={lightBoxPayload?.show_after ? lightBoxPayload?.show_after : ''}
                                onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                                className="input-small"
                            />
                            sec on page:
                            <input
                                type="number"
                                name="show_on_page"
                                min="0"
                                value={lightBoxPayload?.show_on_page ? lightBoxPayload?.show_on_page : ''}
                                onChange={handleChange}
                                onFocus={(e) => e.target.select()}
                                className="input-small"
                                placeholder="any"
                            />
                        </span>
                    )}
                </span>
            </label>
        ))}
    </div>
)
export default LightBoxTrigger
